export const getTailoringTrialTypeList = state => {
    return state.list
}

export const getTailoringTrialTypeDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringTrialType/getters.js